// LoginButton.js
import React from 'react';
import './LoginButton.css'; // Assurez-vous d'avoir ce fichier CSS avec les styles appropriés

const LoginButton = ({ showLogin, handleLogin }) => {
  return (
    <button
      type="submit"
      className={`login-form-button ${showLogin ? 'show' : ''}`}
      onClick={handleLogin}
    >
      <span className={`login-form-button-span ${showLogin ? 'show' : ''}`}>
        Connexion
      </span>
    </button>
  );
};

export default LoginButton;
